import React from "react";
import * as Acc from "@radix-ui/react-accordion";
import { Plus, Minus } from "lucide-react";
import { RESEARCH, RESEARCH_NOTE } from "../../content/research";

const FOCUS = "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#ebc754]";

const Paper = ({ p }) => (
  <li className="py-6 border-t border-[#f2e5de]/15 first:border-t-0 grid sm:grid-cols-[3rem_1fr] gap-x-4 gap-y-2" data-testid={`research-paper-${p.n}`}>
    <span className="feral-serif text-[#ebc754] text-lg">{String(p.n).padStart(2, "0")}</span>
    <div>
      <p className="feral-nav uppercase tracking-[0.08em] text-xs text-[#ebc754]">{p.author}</p>
      <h4 className="mt-2 text-[#f2e5de] text-base md:text-lg font-semibold leading-snug">{p.title}</h4>
      <p className="mt-2 text-[#f2e5de]/80 font-light leading-relaxed max-w-3xl">{p.summary}</p>
      <a href={p.url} target="_blank" rel="noopener noreferrer" className={`mt-3 inline-block text-sm text-[#ebc754] border-b border-[#ebc754]/60 pb-0.5 hover:text-[#f2e5de] hover:border-[#f2e5de] transition-colors ${FOCUS}`} data-testid={`research-link-${p.n}`}>
        Read the paper ↗<span className="sr-only"> (opens in a new tab)</span>
      </a>
    </div>
  </li>
);

export const ResearchPanel = ({ open }) => (
  <div id="research-panel" hidden={!open} className="mt-14 border-t border-[#f2e5de]/20 pt-10" data-testid="research-panel">
    <p className="text-sm md:text-base text-[#f2e5de]/75 font-light leading-relaxed max-w-3xl" data-testid="research-note">{RESEARCH_NOTE}</p>
    <Acc.Root type="multiple" className="mt-10 border-t border-[#f2e5de]/20">
      {RESEARCH.map((g) => (
        <Acc.Item key={g.key} value={g.key} className="border-b border-[#f2e5de]/20">
          <Acc.Header>
            <Acc.Trigger className={`group w-full flex items-center justify-between gap-6 py-6 md:py-7 text-left ${FOCUS}`} data-testid={`research-group-${g.key}`}>
              <span className="flex items-baseline gap-4 flex-wrap">
                <span className="feral-serif text-[#ebc754] text-3xl md:text-4xl">{g.title}</span>
                <span className="text-sm text-[#f2e5de]/60">{g.papers.length} papers</span>
              </span>
              <Plus size={22} className="shrink-0 text-[#ebc754] group-data-[state=open]:hidden" aria-hidden="true" />
              <Minus size={22} className="shrink-0 text-[#ebc754] hidden group-data-[state=open]:block" aria-hidden="true" />
            </Acc.Trigger>
          </Acc.Header>
          <Acc.Content className="overflow-hidden data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down">
            <div className="pb-8">
              <p className="text-[#f2e5de]/85 font-light leading-relaxed">{g.intro}</p>
              <ol className="mt-4">{g.papers.map((p) => <Paper key={p.n} p={p} />)}</ol>
            </div>
          </Acc.Content>
        </Acc.Item>
      ))}
    </Acc.Root>
  </div>
);
